// Developer     : Nicolas Pascucci
// Creation Date : 15-7-2024
// Version       : 1
// Description   :
import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  Grid,
  FormGroup,
  Typography,
  Paper,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import InputMask from "react-input-mask";
import { FormHelperText } from "@mui/material";
//Funciones Propias
import { getData, getCodeArg } from "../../../../services/library";
import DialogProPre from "./DialogProPre";
import ErrorDialog from "../../../Dialogs/ErrorDialog";
import InfoText from "../../helper/InfoText";
import {
  verificarCuit,
  verificarDni,
} from "../validacionDatos/ValidacionDatos";
import BuscadorClienteFactura from "../BusquedaCliente/BuscadorClienteFactura";

function AltaClienteEnv(props) {
  const [buscandoClienteSeleccionado, setBuscandoClienteSeleccionado] =
    useState(false);
  //Estados que guardarán los datos necesarios para completar los datos del formulario.
  const [codArg, setCodArg] = useState("");
  const [sucursales, setSucursales] = useState(null);
  const [localidades, setLocalidades] = useState(null);
  const [comerciales, setComerciales] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [condiciones, setCondiciones] = useState(null);
  // const [categorias, setCategorias] = useState(null);
  const [convenios, setConvenios] = useState(null)
  const [sitIva, setSitIva] = useState(null);
  const [tipoCliente, setTipoCliente] = useState(null);
  const [usos, setUsos] = useState(null);
  const [productoPredeterminado, setProductoPredeterminado] = useState(false);
  // PARA AUTOCOMPLETES
  const [sitIvaSeleccionada, setSitIvaSeleccionada] = useState("");
  const [convenioSeleccionado, setConvenioSeleccionado] = useState("")
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState("");
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [buscando, setBuscando] = useState(false);
  const [cambieProv, setCambieProv] = useState(false);
  const [cambieSuc, setCambieSuc] = useState(false);
  const [clienteFactura, setClienteFactura] = useState(null);
  const opcionesFacturarA = [
    { id: "SELF", razon_social: "Facturación Propia" },
    // ...clientes,
  ];
  // Variables o estados que manejan componentes visuales
  const size = "small";
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const [errorDialog, setErrorDialog] = useState(false);
  // switch cons final
  const [checked, setChecked] = useState(
    props.dataCliente.factura_consfinal === 1 ? true : false,
  );
  // console.log("SIT IVA SELECCIONADA",sitIvaSeleccionada);
  // console.log("CONVENIO", convenioSeleccionado);
  

  const [checkedPrecioEspecial, setCheckedPrecioEspecial] = useState(
    props.dataCliente.precio_especial === 1 ? true : false,
  );

  const [checkedEntregaConRemito, setCheckedEntregaConRemito] = useState(
    props.dataCliente.entrega_con_remito === 1 ? true : false,
  );
  const handleChangeChecked = (event) => {
    setChecked(event.target.checked);
  };
  const handleCheckedPrecioEspecial = (event) => {
    setCheckedPrecioEspecial(event.target.checked);
  };

  const handleCheckedEntregaConRemito = (event) => {
    setCheckedEntregaConRemito(event.target.checked);
  };
  

  const formatearIIBB = (valor) => {
  if (!valor) return '';
  
  // Eliminar todo lo que no sea número
  let numeros = valor.replace(/\D/g, '');
  
  // Limitar a 10 números máximo (3+6+1)
  if (numeros.length > 10) {
    numeros = numeros.slice(0, 10);
  }
  
  // Aplicar formato progresivo mientras escribe
  if (numeros.length <= 3) {
    return numeros;
  } else if (numeros.length <= 9) {
    return `${numeros.slice(0, 3)}-${numeros.slice(3)}`;
  } else {
    return `${numeros.slice(0, 3)}-${numeros.slice(3, 9)}-${numeros.slice(9, 10)}`;
  }
};
  //--------------------- FUNCIONES ---------------------//
  //Obtengo por única vez al momento de carga del componente y mediante llamadas a la api, los siguientes datos necesarios para rellenar el formulario:
  useEffect(() => {
    // getData("/categorias", setCategorias);
    getData("/convenios", setConvenios);
    getData("/provincias", setProvincias);
    getData("/condicion_pago", setCondiciones);
    getData("/condiciones_iva/envasado", setSitIva);
    getData("/tipoclienteenvasado", setTipoCliente);
    getData("/sucursales", setSucursales);
    getData("/envasado_usos", setUsos);
    getCodeArg(setCodArg);
  }, []);

  //Esta función almacena en estado los datos pertinentes al cliente que ingreso en el formulario.
  // const almacenar = (e) => {
  //   props.setDataCliente({
  //     ...props.dataCliente,
  //     [e.target.name]: e.target.value === "" ? null : e.target.value,
  //   });
  // };

const almacenar = (e) => {
  let valor = e.target.value === "" ? null : e.target.value;
  
  // Formatear solo para IIBB cuando convenio es 1
  if (e.target.name === "iibb_nro_inscripcion" && convenioSeleccionado?.id_convenio === 1 && valor) {
    const numeros = valor.replace(/\D/g, ''); // Solo números
    if (numeros.length <= 3) valor = numeros;
    else if (numeros.length <= 9) valor = `${numeros.slice(0, 3)}-${numeros.slice(3)}`;
    else valor = `${numeros.slice(0, 3)}-${numeros.slice(3, 9)}-${numeros.slice(9, 10)}`;
  }
  
  props.setDataCliente({
    ...props.dataCliente,
    [e.target.name]: valor,
  });
};

useEffect(() => {
  // Si el campo iibb_nro_inscripcion tiene valor, lo limpiamos
  if (props.dataCliente.iibb_nro_inscripcion) {
    props.setDataCliente({
      ...props.dataCliente,
      iibb_nro_inscripcion: "",
    });
  }
}, [convenioSeleccionado?.id_convenio]); 

  //Si escogí una provincia y una localidad, y luego vuelvo a cambiar la provincia, inicio nuevamente la localidad en string vacío.
  useEffect(() => {
    if (cambieProv) {
      props.dataCliente.id_localidad = "";
      setLocalidadSeleccionada("");
    }
    getData(
      "/localidades/prov/" + props.dataCliente.id_provincia,
      setLocalidades,
      setBuscando(false),
    );
  }, [props.dataCliente.id_provincia, cambieProv]);

  useEffect(() => {
    if (cambieSuc) {
      props.dataCliente.id_comercial = null;
    }
    if (Object.keys(sucursalSeleccionada).length !== 0) {
      getData(
        "/representantes/xsucursal/" + sucursalSeleccionada.id,
        setComerciales,
      );
    }
  }, [sucursalSeleccionada, cambieSuc]);

  // Pone la direccion fiscal como direccion de entrega
  const setAsDeliverySite = (e) => {
    props.setEsDomEntrega(e.target.checked); //Guardamos en el estado esDomEntrega, si checked es true or false
    if (e.target.checked) {
      //SI ES DOMICILIO DE ENTREGA:
      //Primero, compruebo que no haya nada en el índice 0:
      if (
        !props.listaDom[0].nombre_direccion &&
        !props.listaDom[0].id_provincia &&
        !props.listaDom[0].id_localidad &&
        !props.listaDom[0].telefono_1 &&
        !props.listaDom[0].telefono_2 &&
        !props.listaDom[0].telefono_3 &&
        !props.listaDom[0].mails
      ) {
        //Si no hay nada en el índice 0, entonces ubico el domicilio fiscal allí
        const listaDom = [...props.listaDom];
        // Modificar solo el valor deseado en el objeto en el índice 0
        listaDom[0] = {
          ...props.listaDom[0],
          id_provincia: props.dataCliente.id_provincia,
          id_localidad: props.dataCliente.id_localidad,
          id_sucursal: props.dataCliente.id_sucursal,
          telefono_1: props.dataCliente.telefono_1,
          telefono_2: props.dataCliente.telefono_2,
          telefono_3: props.dataCliente.telefono_3,
          mails: props.dataCliente.mails,
          nombre_direccion: props.dataCliente.direccion_fiscal,
          id_producto: props.dataCliente.id_tipocliente === 1 ? 1 : "",
          es_domicilio_fiscal: true,
        };
        props.setListaDom(listaDom);
      } else {
        //Si hay datos en el índice 0, entonces, añado un nuevo registro de domicilio de entrega:
        props.setListaDom([
          ...props.listaDom,
          {
            nro_dir: props.uuid,
            direccion_entrega: "",
            nombre_direccion: props.dataCliente.direccion_fiscal,
            id_provincia: props.dataCliente.id_provincia,
            id_localidad: props.dataCliente.id_localidad,
            id_sucursal: props.dataCliente.id_sucursal,
            contacto: "",
            telefono_1: props.dataCliente.telefono_1,
            telefono_2: props.dataCliente.telefono_2,
            telefono_3: props.dataCliente.telefono_3,
            mails: props.dataCliente.mails,
            latitud: "",
            longitud: "",
            usuario: localStorage.getItem("user"),
            activo: 1,
            verificada: 1,
            id_producto: props.dataCliente.id_tipocliente === 1 ? 1 : "",
            es_domicilio_fiscal: true,
          },
        ]);
      }
      //SI CANCELO QUE SEA EL DOMICILIO DE ENTREGA:
    } else {
      //Si el domicilio fiscal era el único, no voy a borrar lista Dom, si no que voy a volver a iniciarlo con los valores en nada.
      if (props.listaDom.length === 1) {
        props.setListaDom([
          {
            nro_dir: props.uuid,
            direccion_entrega: "",
            nombre_direccion: "",
            id_provincia: "",
            id_localidad: "",
            id_sucursal: "",
            contacto: "",
            telefono_1: "",
            telefono_2: "",
            telefono_3: "",
            mails: "",
            latitud: "",
            longitud: "",
            usuario: localStorage.getItem("user"),
            activo: 1,
            verificada: 1,
            id_producto: props.dataCliente.id_tipocliente === 1 ? 1 : "",
          },
        ]);
      } else if (props.listaDom.length > 1) {
        const listaDom = props.listaDom.filter(
          (domicilio) => !domicilio.es_domicilio_fiscal,
        );
        // Establecer el nuevo estado sin el domicilio fiscal
        props.setListaDom(listaDom);
      }
    }
  };

  //Si está tildado "esDomEntrega", esta función, lo que hace es reflejar las modificaciones que pueda haber luego de tildar el checkBox, a la dirección de entrega que se corresponde con la fiscal.
  const handleChangeDatosDir = (e) => {
    almacenar(e);
    e.target.name === "id_provincia" && setCambieProv(true);
    e.target.name === "id_sucursal" && setCambieSuc(true);
    props.esDomEntrega && almacenarFiscalAsEntrega(e);
  };

  const almacenarFiscalAsEntrega = (e) => {
    //Si es domicilio de entrega, debe setearse en listaDom, donde el indice indica la posición del registro que es_domicilio_fiscal
    const listaDom = [...props.listaDom];
    const domFiscalIndex = listaDom.findIndex(
      (domicilio) => domicilio.es_domicilio_fiscal === true,
    ); //Obtiene la posición del json donde está la dirección fiscal para poder modificar.

    if (domFiscalIndex !== -1) {
      //Si el índice existe
      listaDom[domFiscalIndex] = {
        ...listaDom[domFiscalIndex],
        [e.target.name]: e.target.value,
      };
      props.setListaDom(listaDom);
    }
  };

  // guardar el estado de lo seleccionado y que se ponga cuando vuelvas al componente
  useEffect(() => {
    // sit Iva
    if (props.dataCliente.situacion_iva !== "" && sitIva) {
      const sitIvaEncontrada = sitIva.find(
        (d) => d.id === props.dataCliente.situacion_iva,
      );
      if (sitIvaEncontrada) {
        setSitIvaSeleccionada(sitIvaEncontrada);
      }
    }
    // provincia
    if (props.dataCliente.id_provincia !== "" && provincias) {
      const provinciaEncontrada = provincias.find(
        (d) => d.id === props.dataCliente.id_provincia,
      );
      if (provinciaEncontrada) {
        setProvinciaSeleccionada(provinciaEncontrada);
      }
    }
    // localidad
    if (props.dataCliente.id_localidad !== "" && localidades) {
      const localidadEncontrada = localidades.find(
        (d) => d.id === props.dataCliente.id_localidad,
      );
      if (localidadEncontrada) {
        setLocalidadSeleccionada(localidadEncontrada);
      }
    }
    // sucursal
    if (props.dataCliente.id_sucursal !== "" && sucursales) {
      const sucursalEncontrada = sucursales.find(
        (d) => d.id === props.dataCliente.id_sucursal,
      );
      if (sucursalEncontrada) {
        setSucursalSeleccionada(sucursalEncontrada);
      }
    }

    // id_convenio
    if (props.dataCliente.id_convenio !== "" && convenios) {
      const ConvenioEncontrado = convenios.find(
        (d) => d.id_convenio === props.dataCliente.id_convenio,
      );
      if (ConvenioEncontrado) {
        setConvenioSeleccionado(ConvenioEncontrado);
      }
    }
  }, [props.dataCliente, sitIva, provincias, localidades, sucursales, convenios]);

  useEffect(() => {
    let respInscrip = sitIvaSeleccionada?.id === 1 ? 1.75 : null;
    let tieneExencion =
      sitIvaSeleccionada?.id === 1 ? props.dataCliente.porc_exc_perc_iva : null;
    let vencimientoExencion =
      sitIvaSeleccionada?.id === 1 ? props.dataCliente.vto_exc_perc_iva : null;

    if (sitIvaSeleccionada?.id === 4) {
      props.setDataCliente((prev) => ({
        ...prev,
        porc_perc_iva: respInscrip,
        porc_exc_perc_iva: tieneExencion,
        vto_exc_perc_iva: vencimientoExencion,
      }));
    } else if (
      Object.keys(sitIvaSeleccionada).length !== 0 &&
      sitIvaSeleccionada?.id !== 4
    ) {
      props.setTipo(80);
      props.setDataCliente((prev) => ({
        ...prev,
        tipo_doc_afip: 80,
        porc_perc_iva: respInscrip,
        porc_exc_perc_iva: tieneExencion,
        vto_exc_perc_iva: vencimientoExencion,
      }));
    }
  }, [sitIvaSeleccionada]);

  useEffect(() => {
    if (checked === true) {
      props.setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 1,
      }));
    } else {
      props.setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 0,
      }));
    }
  }, [checked]);

  useEffect(() => {
    if (checkedPrecioEspecial === true) {
      props.setDataCliente((prev) => ({
        ...prev,
        precio_especial: 1,
      }));
    } else {
      props.setDataCliente((prev) => ({
        ...prev,
        precio_especial: 0,
      }));
    }
  }, [checkedPrecioEspecial]);

  useEffect(() => {
    if (checkedEntregaConRemito === true) {
      props.setDataCliente((prev) => ({
        ...prev,
        entrega_con_remito: 1,
      }));
    } else {
      props.setDataCliente((prev) => ({
        ...prev,
        entrega_con_remito: 0,
      }));
    }
  }, [checkedEntregaConRemito]);

  const handleClienteFacturaChange = (cliente) => {
    setClienteFactura(cliente);

    if (cliente?.id === "SELF") {
      props.setDataCliente((prev) => ({
        ...prev,
        facturar_a: "SELF",
        facturar_a_nombre: "Facturación Propia",
      }));
    } else if (cliente) {
      props.setDataCliente((prev) => ({
        ...prev,
        facturar_a: cliente.id,
        facturar_a_nombre: cliente.razon_social,
      }));
    } else {
      props.setDataCliente((prev) => ({
        ...prev,
        facturar_a: null,
        facturar_a_nombre: null,
      }));
    }
  };

  // Y en el useEffect:
  useEffect(() => {
    if (!props.dataCliente.facturar_a) {
      setClienteFactura(null);
      return;
    }

    if (clienteFactura && clienteFactura.id === props.dataCliente.facturar_a) {
      return;
    }

    if (props.dataCliente.facturar_a === "SELF") {
      setClienteFactura({
        id: "SELF",
        razon_social: "Facturación Propia",
      });
    } else if (props.dataCliente.facturar_a_nombre) {
      setClienteFactura({
        id: props.dataCliente.facturar_a,
        razon_social: props.dataCliente.facturar_a_nombre,
      });
    }
  }, [
    props.dataCliente.facturar_a,
    props.dataCliente.facturar_a_nombre,
    clienteFactura,
  ]);

  useEffect(() => {
    if (!props.dataCliente.facturar_a) {
      setClienteFactura(null);
      return;
    }

    if (clienteFactura && clienteFactura.id === props.dataCliente.facturar_a) {
      return;
    }

    if (props.dataCliente.facturar_a === "SELF") {
      setClienteFactura({
        id: "SELF",
        razon_social: "Facturación Propia",
      });
    } else if (props.dataCliente.facturar_a_nombre) {
      setClienteFactura({
        id: props.dataCliente.facturar_a,
        razon_social: props.dataCliente.facturar_a_nombre,
      });
    }
  }, [
    props.dataCliente.facturar_a,
    props.dataCliente.facturar_a_nombre,
    clienteFactura,
  ]);

  return (
    <div>
      <Container maxWidth="xl" disabledGutters>
        <form>
          <Box
            mt={1}
            backgroundColor="#ebebeb"
            p={1.5}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid container spacing={1.3}>
              <Grid item xs={3}>
                <TextField
                  autoFocus
                  size={size}
                  style={style}
                  placeholder="Razon Social"
                  type="text"
                  required
                  name="razon_social"
                  id="razon_social"
                  label="Razon Social"
                  onChange={almacenar}
                  value={
                    props.dataCliente.razon_social &&
                    props.dataCliente.razon_social.replace(/\b\w/g, (l) =>
                      l.toUpperCase(),
                    )
                  }
                  inputProps={{ maxLength: 200 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 3}>
                <TextField
                  size={size}
                  style={style}
                  placeholder="Sisven ID"
                  type="text"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{ maxLength: 6 }}
                  name="sisven_id"
                  label="Sisven ID"
                  color="primary"
                  onChange={almacenar}
                  value={props.dataCliente.sisven_id}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MeetingRoomIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 3}>
                <FormControl style={style} required size={size}>
                  <InputLabel> Tipo Cliente</InputLabel>
                  <Select
                    label="Tipo Cliente"
                    name="id_tipocliente"
                    value={props.dataCliente.id_tipocliente}
                    onChange={(e) => {
                      almacenar(e);
                    }}
                  >
                    {tipoCliente
                      ? tipoCliente.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.descripcion}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  disabled={!sitIva}
                  required
                  disableClearable
                  id="sitIva"
                  style={style}
                  size={size}
                  noOptionsText={"Situacion de IVA INEXISTENTE"}
                  options={sitIva}
                  autoHighlight
                  getOptionLabel={(sitIva) =>
                    sitIva.id + "-" + sitIva.descripcion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={sitIvaSeleccionada || null}
                  defaultValue={sitIvaSeleccionada || null}
                  onChange={(event, value) => {
                    setSitIvaSeleccionada(value);
                    props.setSitIvaSeleccionada(value);

                    const syntheticEvent = {
                      target: {
                        name: "situacion_iva",
                        value: value ? value.id : null,
                      },
                    };
                    almacenar(syntheticEvent);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id} - {option.descripcion}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      required
                      {...params}
                      label="Situacion Iva"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              {sitIvaSeleccionada?.id === 1 ? (
                <>
                  <Grid item xs={1.5}>
                    <TextField
                      size={size}
                      style={style}
                      fullWidth
                      required
                      placeholder=""
                      disabled={sitIvaSeleccionada?.id === 1 ? false : true}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      inputProps={{ maxLength: 9 }}
                      name="porc_exc_perc_iva"
                      label="% Exención Perc. IVA"
                      color="primary"
                      onChange={almacenar}
                      value={props.dataCliente.porc_exc_perc_iva}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <TextField
                      size={size}
                      style={style}
                      fullWidth
                      required={
                        props.dataCliente.porc_exc_perc_iva > 0 ? true : false
                      }
                      placeholder=""
                      disabled={sitIvaSeleccionada?.id === 1 ? false : true}
                      type="date"
                      inputProps={{ maxLength: 9 }}
                      name="vto_exc_perc_iva"
                      label="Vencimiento Exención"
                      color="primary"
                      onChange={almacenar}
                      value={props.dataCliente.vto_exc_perc_iva}
                      InputProps={{
                        startAdornment: <InputAdornment position="start" />,
                      }}
                    />
                  </Grid>
                </>
              ) : null}
              {/* <Grid item xs={4}>
                <FormControl style={style} size={size}>
                  <InputLabel>Categoría Crediticia</InputLabel>
                  <Select
                    name="id_categoria"
                    value={props.dataCliente.id_categoria}
                    label="Categoria crediticia"
                    onChange={almacenar}
                  >
                    {categorias
                      ? categorias.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.categoria} ({elemento.descripcion})
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item xs={3}>
                <TextField
                  size={size}
                  style={style}
                  fullWidth
                  placeholder="100000"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{ maxLength: 9 }}
                  name="limite_credito"
                  label="Límite de crédito"
                  color="primary"
                  onChange={almacenar}
                  value={props.dataCliente.limite_credito}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </Grid> */}
              <Grid item xs={4.2}>
                <TextField
                  size={size}
                  required
                  style={style}
                  placeholder="Direccion Fiscal"
                  id="direccion_fiscal"
                  name="direccion_fiscal"
                  label="Direccion Fiscal"
                  color="primary"
                  value={
                    props.dataCliente.direccion_fiscal &&
                    props.dataCliente.direccion_fiscal.replace(/\b\w/g, (l) =>
                      l.toUpperCase(),
                    )
                  }
                  onChange={almacenar}
                  inputProps={{ maxLength: 120 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationOnIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={2.2}>
                <Autocomplete
                  disabled={!provincias}
                  required
                  disableClearable
                  id="provincia"
                  style={style}
                  size={size}
                  noOptionsText={"Provincia INEXISTENTE"}
                  options={provincias}
                  autoHighlight
                  getOptionLabel={(provincia) =>
                    provincia.id + "-" + provincia.provincia
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={provinciaSeleccionada || null}
                  defaultValue={provinciaSeleccionada || null}
                  onChange={(event, value) => {
                    setProvinciaSeleccionada(value);
                    props.setProvinciaSeleccionada(value);
                    const syntheticEvent = {
                      target: {
                        name: "id_provincia",
                        value: value ? value.id : null,
                      },
                    };
                    handleChangeDatosDir(syntheticEvent);
                    setBuscando(true);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id} - {option.provincia}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      required
                      label="Provincia"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                {buscando === true ? (
                  <TextField
                    disabled
                    focused
                    fullWidth
                    size={size}
                    label="Buscando Localidades..."
                  />
                ) : (
                  <Autocomplete
                    disabled={!localidades}
                    required
                    disableClearable
                    id="localidad"
                    name="id_localidad"
                    style={style}
                    size={size}
                    noOptionsText={"Localidad INEXISTENTE"}
                    options={localidades}
                    autoHighlight
                    // getOptionLabel={(localidad) =>
                    //   localidad.id + "-" + localidad.localidad
                    // }
                    getOptionLabel={
                      (localidad) => localidad.cp + " - " + localidad.localidad // Cambiado: muestra CP en lugar de ID
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={localidadSeleccionada || null}
                    defaultValue={localidadSeleccionada || null}
                    onChange={(event, value) => {
                      setLocalidadSeleccionada(value);
                      props.setLocalidadSeleccionada(value);
                      const syntheticEvent = {
                        target: {
                          name: "id_localidad",
                          value: value ? value.id : null,
                        },
                      };
                      handleChangeDatosDir(syntheticEvent);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {/* {option.id} - {option.localidad} */}
                        {option.cp} - {option.localidad}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        required
                        label="Localidad"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={2.6}>
                <Paper
                  elevation={0}
                  sx={{
                    // p: 0.5,
                    border: "2px solid",
                    borderColor: props.esDomEntrega
                      ? "primary.main"
                      : "grey.300",
                    borderRadius: 3,
                    height: 38,
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    bgcolor: props.esDomEntrega ? "primary.50" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": {
                      borderColor: "primary.main",
                      bgcolor: props.esDomEntrega ? "primary.100" : "grey.50",
                      transform: "translateY(-2px)",
                      boxShadow: 2,
                    },
                  }}
                  // onClick={handleCheckedEntregaConRemito}
                  onClick={() => {
                    // Crear un evento sintético
                    const syntheticEvent = {
                      target: {
                        checked: !props.esDomEntrega,
                      },
                    };
                    setAsDeliverySite(syntheticEvent);
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    width="100%"
                  >
                    <Checkbox
                      checked={props.esDomEntrega}
                      // onChange={(e) => setAsDeliverySite(e)}
                      tabIndex={-1}
                      disableRipple
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 28 },
                      }}
                    />
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ userSelect: "none" }}
                    >
                      Domicilio de entrega
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={1}>
                <FormControl style={style} size={size}>
                  <InputLabel>Cuit/Dni</InputLabel>
                  <Select
                    name="tipo_doc_afip"
                    // autoFocus
                    disabled={sitIvaSeleccionada?.id !== 4}
                    labelId="Cuit/Dni"
                    value={props.dataCliente.tipo_doc_afip} // Forzá a CUIT si no es 4
                    label="Cuit/Dni"
                    onChange={almacenar}
                  >
                    <MenuItem key={props.tipo} value={80}>
                      Cuit
                    </MenuItem>
                    <MenuItem key={props.tipo} value={96}>
                      Dni
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {props.dataCliente.tipo_doc_afip === 80 ? (
                <Grid item xs={2}>
                  <InputMask
                    mask="99999999999"
                    value={props.dataCliente.cuit}
                    disabled={false}
                    maskChar=""
                    onChange={(e) =>
                      props.setDataCliente({
                        ...props.dataCliente,
                        cuit: e.target.value,
                      })
                    }
                    onBlur={(e) => {
                      verificarCuit(
                        props.dataCliente,
                        props.setDataCliente,
                        setErrorDialog,
                      );
                    }}
                  >
                    {() => (
                      <TextField
                        size={size}
                        style={style}
                        required={
                          props.dataCliente.situacion_iva === 4 ? false : true
                        }
                        defaultValue=""
                        type="text"
                        name="cuit"
                        label="Numero Cuit"
                      />
                    )}
                  </InputMask>
                </Grid>
              ) : props.dataCliente.tipo_doc_afip === 96 ? (
                <Grid item xs={2}>
                  <InputMask
                    mask="99999999"
                    value={props.dataCliente.cuit}
                    disabled={false}
                    maskChar=""
                    onChange={(e) =>
                      props.setDataCliente({
                        ...props.dataCliente,
                        cuit: e.target.value,
                      })
                    }
                    onBlur={() =>
                      verificarDni(
                        props.dataCliente,
                        props.setDataCliente,
                        setErrorDialog,
                      )
                    }
                  >
                    {() => (
                      <TextField
                        size={size}
                        style={style}
                        defaultValue=""
                        required={
                          props.dataCliente.situacion_iva === 4 ? false : true
                        }
                        type="text"
                        name="cuit"
                        label="Numero Dni"
                      />
                    )}
                  </InputMask>
                </Grid>
              ) : null}
              <Grid item xs={2}>
                <FormControl required style={style} size={size}>
                  <InputLabel>Condición de pago</InputLabel>
                  <Select
                    name="id_condicionpago"
                    labelId="id_condicionpago"
                    value={props.dataCliente.id_condicionpago}
                    label="Condición de pago"
                    onChange={almacenar}
                  >
                    {condiciones
                      ? condiciones.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.condicion}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2.5}>
                <Autocomplete
                  disabled={!sucursales}
                  required
                  disableClearable
                  id="sucursal"
                  style={style}
                  size={size}
                  noOptionsText={"Sucursal INEXISTENTE"}
                  options={sucursales}
                  autoHighlight
                  getOptionLabel={(sucursal) =>
                    sucursal.id + "-" + sucursal.nombre
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={sucursalSeleccionada || null}
                  defaultValue={sucursalSeleccionada || null}
                  onChange={(event, value) => {
                    setSucursalSeleccionada(value);
                    props.setSucursalSeleccionada(value);
                    const syntheticEvent = {
                      target: {
                        name: "id_sucursal",
                        value: value ? value.id : null,
                      },
                    };
                    handleChangeDatosDir(syntheticEvent);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id} - {option.nombre}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Sucursal"
                      required
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2.5}>
                <FormControl fullWidth size={size}>
                  <InputLabel id="lblcomercial">Comercial</InputLabel>
                  <Select
                    style={{ backgroundColor: "#FFFFFF" }}
                    labelId="lblcomercial"
                    label="Comercial"
                    name="id_comercial"
                    value={props.dataCliente.id_comercial || ""}
                    onChange={almacenar}
                  >
                    {comerciales && comerciales.length > 0 ? (
                      comerciales.map((elemento) => (
                        <MenuItem key={elemento.id} value={elemento.id}>
                          {elemento.nombre_apellido}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled value="">
                        No hay comerciales disponibles
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={1.5}>
                <FormControl fullWidth>
                  <TextField
                    size={size}
                    style={{ backgroundColor: "#fff" }}
                    fullWidth
                    type="number"
                    color="primary"
                    placeholder="..."
                    name="envase_10_kg"
                    label="Envase 10 KG"
                    onChange={(e) => almacenar(e)}
                    value={props.dataCliente.envase_10_kg}
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      style: {
                        MozAppearance: "textfield",
                      },
                    }}
                    InputProps={{
                      sx: {
                        "& input::-webkit-outer-spin-button": {
                          display: "none",
                        },
                        "& input::-webkit-inner-spin-button": {
                          display: "none",
                        },
                      },
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1.5}>
                <FormControl fullWidth>
                  <TextField
                    size={size}
                    style={{ backgroundColor: "#fff" }}
                    fullWidth
                    type="number"
                    color="primary"
                    placeholder="..."
                    name="envase_15_kg"
                    label="Envase 15 KG"
                    onChange={(e) => almacenar(e)}
                    value={props.dataCliente.envase_15_kg}
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      style: {
                        MozAppearance: "textfield",
                      },
                    }}
                    InputProps={{
                      sx: {
                        "& input::-webkit-outer-spin-button": {
                          display: "none",
                        },
                        "& input::-webkit-inner-spin-button": {
                          display: "none",
                        },
                      },
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1.5}>
                <FormControl fullWidth>
                  <TextField
                    size={size}
                    style={{ backgroundColor: "#fff" }}
                    fullWidth
                    type="number"
                    color="primary"
                    placeholder="..."
                    name="envase_45_kg"
                    label="Envase 45 KG"
                    onChange={(e) => almacenar(e)}
                    value={props.dataCliente.envase_45_kg}
                    //  inputProps={{
                    //   maxLength: 10,
                    // }} Lo que estaba antes en los 3 inputs
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      style: {
                        MozAppearance: "textfield",
                      },
                    }}
                    InputProps={{
                      sx: {
                        "& input::-webkit-outer-spin-button": {
                          display: "none",
                        },
                        "& input::-webkit-inner-spin-button": {
                          display: "none",
                        },
                      },
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </FormControl>
              </Grid> */}

              <Grid item xs={2}>
                <FormControl fullWidth size={size}>
                  <InputLabel>Uso</InputLabel>
                  <Select
                    style={{ backgroundColor: "#FFFFFF" }}
                    name="uso"
                    labelId="uso"
                    value={props.dataCliente.uso}
                    label="Uso"
                    onChange={almacenar}
                  >
                    {usos
                      ? usos.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.uso}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              {sitIvaSeleccionada?.inscripcion_iibb===1?
              <>
              <Grid item xs={2.5}>
                <Autocomplete
                  disabled={!convenios}
                  required
                  disableClearable
                  id="convenios"
                  style={style}
                  size={size}
                  noOptionsText={"Convenio INEXISTENTE"}
                  options={convenios}
                  autoHighlight
                  getOptionLabel={(c) =>
                    c.id_convenio + "-" + c.convenio
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id_convenio === value?.id_convenio
                  }
                  value={convenioSeleccionado || null}
                  defaultValue={convenioSeleccionado || null}
                  onChange={(event, value) => {
                    setConvenioSeleccionado(value);
                    props.setConvenioSeleccionado(value);

                    const syntheticEvent = {
                      target: {
                        name: "id_convenio",
                        value: value ? value.id_convenio : null,
                      },
                    };
                    almacenar(syntheticEvent);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id_convenio}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_convenio} - {option.convenio}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      // required
                      {...params}
                      label="Convenio"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
<Grid item xs={2.5}>
  <TextField
    size={size}
    style={style}
    placeholder="N° Inscripción IIBB"
    id="iibb_nro_inscripcion"
    name="iibb_nro_inscripcion"
    label="N° Inscripción IIBB"
    color="primary"
    value={props.dataCliente.iibb_nro_inscripcion || ''}
    onChange={almacenar}
    inputProps={{ maxLength: 200 }}
  />
</Grid>
              </>
              :null}
              <Grid item xs={sitIvaSeleccionada?.inscripcion_iibb===1?7:12}>
                <TextField
                  size={size}
                  style={style}
                  placeholder="Observaciones"
                  id="observaciones"
                  name="observaciones"
                  label="Observaciones"
                  color="primary"
                  value={props.dataCliente.observaciones}
                  onChange={(e) => almacenar(e)}
                  inputProps={{ maxLength: 200 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  placeholder="Mails"
                  id="mails"
                  name="mails"
                  label="Mails"
                  color="primary"
                  // required={props.dataCliente.situacion_iva === 4? false:true}
                  value={props.dataCliente.mails}
                  onChange={(e) => handleChangeDatosDir(e)}
                  inputProps={{ maxLength: 500 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <ContactMailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    size={size}
                    style={{ backgroundColor: "#FFFFFF" }}
                    fullWidth
                    type="text"
                    color="primary"
                    placeholder="Telefono 1"
                    name="telefono_1"
                    label="Telefono 1"
                    value={props.dataCliente.telefono_1}
                    onChange={(e) => handleChangeDatosDir(e)}
                    inputProps={{
                      maxLength: 10,
                    }}
                    required
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {codArg}
                        </InputAdornment>
                      ),
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {/* <InfoText /> */}
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    size={size}
                    style={{ backgroundColor: "#FFFFFF" }}
                    fullWidth
                    type="text"
                    color="primary"
                    // required
                    placeholder="Telefono 2"
                    name="telefono_2"
                    label="Telefono 2"
                    value={props.dataCliente.telefono_2}
                    onChange={(e) => handleChangeDatosDir(e)}
                    inputProps={{
                      maxLength: 10,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {codArg}
                        </InputAdornment>
                      ),
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {/* <InfoText /> */}
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    size={size}
                    style={{ backgroundColor: "#fff" }}
                    fullWidth
                    type="text"
                    color="primary"
                    placeholder="Telefono 3"
                    name="telefono_3"
                    label="Telefono 3"
                    // required
                    onChange={(e) => handleChangeDatosDir(e)}
                    value={props.dataCliente.telefono_3}
                    inputProps={{
                      maxLength: 10,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {codArg}
                        </InputAdornment>
                      ),
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {/* <InfoText /> */}
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <Paper
                  elevation={0}
                  sx={{
                    // p: 0.5,
                    border: "2px solid",
                    borderColor: checked ? "primary.main" : "grey.300",
                    borderRadius: 3,
                    height: 38,
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    bgcolor: checked ? "primary.50" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": {
                      borderColor: "primary.main",
                      bgcolor: checked ? "primary.100" : "grey.50",
                      transform: "translateY(-2px)",
                      boxShadow: 2,
                    },
                  }}
                  onClick={() => setChecked((prev) => !prev)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    width="100%"
                    // onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      checked={checked}
                      // onChange={handleChangeChecked}
                      tabIndex={-1}
                      disableRipple
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 28 },
                      }}
                    />
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ userSelect: "none" }}
                    >
                      Factura Consumidor Final
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={2.5}>
                <Paper
                  elevation={0}
                  sx={{
                    // p: 0.5,
                    border: "2px solid",
                    borderColor: checkedPrecioEspecial
                      ? "primary.main"
                      : "grey.300",
                    borderRadius: 3,
                    height: 38,
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    bgcolor: checkedPrecioEspecial
                      ? "primary.50"
                      : "transparent",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": {
                      borderColor: "primary.main",
                      bgcolor: checkedPrecioEspecial
                        ? "primary.100"
                        : "grey.50",
                      transform: "translateY(-2px)",
                      boxShadow: 2,
                    },
                  }}
                  // onClick={handleCheckedPrecioEspecial}
                  onClick={() => setCheckedPrecioEspecial((prev) => !prev)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    width="100%"
                    // onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      checked={checkedPrecioEspecial}
                      // onChange={handleCheckedPrecioEspecial}
                      tabIndex={-1}
                      disableRipple
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 28 },
                      }}
                    />
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ userSelect: "none" }}
                    >
                      Precio Especial
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={2.5}>
                <Paper
                  elevation={0}
                  sx={{
                    // p: 0.5,
                    border: "2px solid",
                    borderColor: checkedEntregaConRemito
                      ? "primary.main"
                      : "grey.300",
                    borderRadius: 3,
                    height: 38,
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    bgcolor: checkedEntregaConRemito
                      ? "primary.50"
                      : "transparent",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": {
                      borderColor: "primary.main",
                      bgcolor: checkedEntregaConRemito
                        ? "primary.100"
                        : "grey.50",
                      transform: "translateY(-2px)",
                      boxShadow: 2,
                    },
                  }}
                  // onClick={handleCheckedEntregaConRemito}
                  onClick={() => setCheckedEntregaConRemito((prev) => !prev)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    width="100%"
                    // onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      checked={checkedEntregaConRemito}
                      // onChange={handleCheckedEntregaConRemito}
                      tabIndex={-1}
                      disableRipple
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 28 },
                      }}
                    />
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ userSelect: "none" }}
                    >
                      Entrega con Remito
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              {checkedEntregaConRemito && (
                <Grid item xs={12} md={4}>
                  <BuscadorClienteFactura
                    value={clienteFactura}
                    onChange={handleClienteFacturaChange}
                    style={style}
                    size={size}
                    label="Facturar a"
                    placeholder="Buscar cliente por razón social, CUIT..."
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </form>
        <br></br>
        {productoPredeterminado && (
          <DialogProPre
            open={productoPredeterminado}
            setOpen={setProductoPredeterminado}
          />
        )}
        {errorDialog && (
          <ErrorDialog
            open={errorDialog}
            setOpen={setErrorDialog}
            title={"CLIENTE EXISTENTE"}
            subtitle={
              "El CUIT/DNI que intenta ingresar YA FUE REGISTRADO bajo otra razón social. Revise el listado de clientes."
            }
          />
        )}
      </Container>
    </div>
  );
}

export default AltaClienteEnv;
